import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { StartseiteComponent } from './startseite/startseite.component';
import { NaviComponent } from './navi/navi.component';
import { GlobalsVariables } from './global-Variables';
import { LightboxModule } from 'ngx-lightbox';
import { LightelementComponent } from './lightelement/lightelement.component';
import { SliderBgComponent } from './slider-bg/slider-bg.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ImprintComponent } from './imprint/imprint.component';
import { DataPrivacyComponent } from './dataprivacy/dataprivacy.component';
import { SubmenuArtComponent } from './submenu-art/submenu-art.component';
import { SubmenuExComponent } from './submenu-ex/submenu-ex.component';
import { FooterComponent } from './footer/footer.component';
import { VitaComponent } from './vita/vita.component';
import { ContactComponent } from './contact/contact.component';
import { WrapperComponent } from './wrapper/wrapper.component';
import { HeadComponent } from './head/head.component';
import { GaleryComponent } from './galery/galery.component';

@NgModule({
  declarations: [
    AppComponent,
    ImprintComponent,
    StartseiteComponent,
    NaviComponent,
    ContactComponent,
    LightelementComponent,
    SliderBgComponent,
    DataPrivacyComponent,
    SubmenuArtComponent,
    SubmenuExComponent,
    FooterComponent,
    VitaComponent,
    WrapperComponent,
    HeadComponent,
    GaleryComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    LightboxModule,
    BrowserAnimationsModule
  ],
  providers: [ GlobalsVariables ],
  bootstrap: [AppComponent]
})
export class AppModule { }
